module.exports = __webpack_public_path__ + "img/symbol_11_normal.70e64755.png";